import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
export interface EnumMetricItem {
  color: string;
  name: string;
  value: string | number;
  beta?: boolean;
}
export interface EnumMetricItems extends Array<EnumMetricItem> {}
export interface CbDashboardBannerProps {
  metrics: EnumMetricItems;
  isDarkMode?: boolean;
}
export const CbDashboardBanner: FC<CbDashboardBannerProps> = ({
  metrics,
  isDarkMode
}) => {
  const backgroundColor = isDarkMode ? 'darkMode.500' : 'white';
  const textColor = isDarkMode ? 'text.secondaryWhite' : 'text.secondary';
  return <Box bg={backgroundColor} borderRadius="10px" boxShadow="0px 3px 15px 2px rgba(0, 0, 0, 0.0900136)" width="100%" display="flex" flexWrap={{
    base: 'wrap',
    sm: 'nowrap'
  }} justifyContent={{
    base: 'space-around',
    md: 'space-between'
  }} paddingX={5} alignItems="flex-start" data-sentry-element="Box" data-sentry-component="CbDashboardBanner" data-sentry-source-file="CbDashboardBanner.tsx">
      {metrics.map((metric, key) => <Box key={key} height="100%" width={{
      base: 156,
      md: 200
    }} display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" padding="16px" position="relative">
          <Box bg={metric.color} height="3px" width="12rem" position="absolute" top="0" />
          <Text fontSize={{
        base: 'xs',
        sm: '0.65rem'
      }} color={textColor} fontWeight="normal" fontFamily="nunitosans" textAlign="center" marginBottom={1}>
            {metric.name}
          </Text>
          <Text fontSize={{
        base: 'sm',
        sm: '0.75rem',
        md: '16px'
      }} lineHeight={{
        base: 'sm',
        sm: '0.75rem',
        md: '17px'
      }} color={textColor} fontWeight="bold" fontFamily="codenext" textAlign="center" marginX={{
        base: 3,
        sm: 0
      }}>
            {metric?.value?.toLocaleString('en-US')}
          </Text>
        </Box>)}
    </Box>;
};